import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, TextArea } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section7({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-147">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-148">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-149">
          <span className="text-dorado mr-2" data-id="element-150">Sección 07 ·</span>
          Espíritu y Propósito
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-151">
          El bienestar integral incluye tu conexión interior.
        </p>
      </div>

      <FormField label="¿Qué actividades o momentos te hacen sentir verdaderamente conectado/a contigo mismo/a?" name="conexion" error={errors.conexion} required description="Ej. Estar en la naturaleza, leer, orar, pintar, el silencio..." data-id="element-152">
        <TextArea id="conexion" value={data.conexion} onChange={e => onChange('conexion', e.target.value)} error={!!errors.conexion} placeholder="Describe esos momentos..." className="min-h-[100px]" data-id="element-153" />
      </FormField>

      <FormField label="¿Tienes alguna práctica espiritual o de introspección actualmente?" name="practicas" error={errors.practicas} description="(Opcional) No tiene que ser religioso, puede ser journaling, gratitud, etc." data-id="element-154">
        <TextArea id="practicas" value={data.practicas} onChange={e => onChange('practicas', e.target.value)} error={!!errors.practicas} placeholder="Si no tienes ninguna, puedes dejar este espacio en blanco." className="min-h-[100px]" data-id="element-155" />
      </FormField>

      <FormField label="Para ti, ¿qué significa 'despertar del cuerpo'?" name="significado" error={errors.significado} required data-id="element-156">
        <TextArea id="significado" value={data.significado} onChange={e => onChange('significado', e.target.value)} error={!!errors.significado} placeholder="¿Qué te evoca esta frase en relación a tu vida?" className="min-h-[100px]" data-id="element-157" />
      </FormField>
    </div>;
}